<template>
    <div class="card" style="border-width: 0px" v-if="hasRole('Administrator')||hasRole('Berater')||hasRole('Erweiterter Einkäufer')">
        <div class="card-header px-0" style="background-color: #f4f5fa">
            {{ $t("risk.header") }}
        </div>
        <div class="card-body px-0" style="background-color: #f4f5fa">
            <b-tabs>
                <b-tab title="Lieferantenrisiken" active>
                    <SupplierRiskTab />
                </b-tab>
                <b-tab title="Bewertung durchführen">
                    <Calculate />
                </b-tab>
                <b-tab title="Branchenrisiken">
                    <SectorIndicesTab />
                </b-tab>
                <b-tab title="Länderrisiken">
                    <CountryIndicesTab />
                </b-tab>
                <b-tab title="Stammdaten">
                    <Countries ref="countries"></Countries>
                    <Sectors ref="sectors"></Sectors>
                    <Years ref="years"></Years>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Countries from './modules/Countries';
import CountryIndicesTab from './modules/CountryIndicesTab';
import Sectors from './modules/Sectors';
import SectorIndicesTab from './modules/SectorIndicesTab';
import Years from './modules/Years';
import Calculate from './modules/Calculate';
import SupplierRiskTab from './modules/SupplierRiskTab';
import { dateHelper } from '../../../mixins/dateHelper';

export default {
    name: 'supplychainact',
    components: { Countries, Sectors, Years, Calculate, SectorIndicesTab, CountryIndicesTab, SupplierRiskTab },
    mixins: [dateHelper],
    data() {
        return {
            stickyHeader: true,
        }
    },
    created() {
    },
    methods: {

    },
    computed: {
        ...mapGetters({
            hasRole: 'auth/hasRole',
        }),
    }
};
</script>
